import { CHANGE_SUB_LIST_TYPE } from './constants'
import type { ChangeSubListTypeAction, SubListTypeState } from './types'

const initialState: SubListTypeState = {
  channels: 'countries',
  saleTypes: 'countries',
  countries: 'channels',
  owners: 'countries',
}

export default function subListType(state: SubListTypeState = initialState, { payload, type }: ChangeSubListTypeAction) {
  switch (type) {
    case CHANGE_SUB_LIST_TYPE:
      return {
        ...state,
        [payload.channelType]: payload.value,
      }
    default:
      return state
  }
}
